import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';
import { Navigate } from 'react-router-dom';

const AreasIberdrolaRoutes = {
  path: '/areas/iberdrola',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="/i/dashboard/default" replace />
    }
  ]
};

export default AreasIberdrolaRoutes;
